import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const rows = [
  {
    label: "Yangın Dayanımı",
    aksess: "EI 120 sertifikalı panel",
    standard: "Standart çelik konteyner",
    aksessGood: true,
  },
  {
    label: "Isı Transferi",
    aksess: "Mineral yün yalıtım",
    standard: "Minimal yalıtım",
    aksessGood: true,
  },
  {
    label: "Soğutma Sistemi",
    aksess: "Entegre aktif HVAC",
    standard: "Harici ünite gerekli",
    aksessGood: true,
  },
  {
    label: "Enerji Tüketimi",
    aksess: "Optimize edilmiş düşük tüketim",
    standard: "Yüksek parazitik yük",
    aksessGood: true,
  },
  {
    label: "RTE Verim",
    aksess: "%92+",
    standard: "%85–88",
    aksessGood: true,
  },
  {
    label: "Kurulum Süresi",
    aksess: "2–4 hafta",
    standard: "8–16 hafta",
    aksessGood: true,
  },
];

export default function ComparisonSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".comp-row").forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = "1";
              }, i * 80);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="karsilastirma" ref={sectionRef} className="py-24 md:py-32 bg-white">
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Header */}
        <div className="mb-12">
          <span className="text-[#A66A3F] text-xs font-semibold tracking-[0.2em] uppercase">
            Karşılaştırmalı Analiz
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#2B2B2B] mt-3">
            Neden Prefabrike?
          </h2>
        </div>

        {/* Comparison Table */}
        <div className="border border-gray-100 overflow-hidden">
          {/* Column Headers */}
          <div className="grid grid-cols-3 bg-[#FAFAFA] border-b border-gray-100">
            <div className="px-6 py-4 border-r border-gray-100">
              <p className="text-xs text-gray-400 uppercase tracking-widest font-semibold">Özellik</p>
            </div>
            <div className="px-6 py-4 border-r border-gray-100 bg-white border-l-2 border-l-[#A66A3F]">
              <div className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 bg-[#A66A3F] rounded-full" />
                <p className="text-xs font-bold text-[#2B2B2B] uppercase tracking-widest">
                  Prefabrike BESS
                </p>
              </div>
              <p className="text-[10px] text-[#A66A3F] mt-0.5">AKSESS</p>
            </div>
            <div className="px-6 py-4">
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest">
                Standart Konteyner ESS
              </p>
            </div>
          </div>

          {/* Rows */}
          {rows.map((row, i) => (
            <div
              key={row.label}
              className="comp-row grid grid-cols-3 border-b border-gray-100 last:border-b-0 hover:bg-[#FAFAFA] transition-colors duration-150"
              style={{ opacity: 0, transition: "opacity 0.4s ease" }}
            >
              <div className="px-6 py-4 border-r border-gray-100 flex items-center">
                <p className="text-sm text-[#4A4A4A] font-medium">{row.label}</p>
              </div>
              <div className="px-6 py-4 border-r border-gray-100 bg-white border-l-2 border-l-[#A66A3F] flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-[#A66A3F] text-sm font-bold" />
                </div>
                <p className="text-sm font-semibold text-[#2B2B2B]">{row.aksess}</p>
              </div>
              <div className="px-6 py-4 flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-subtract-line text-gray-300 text-sm" />
                </div>
                <p className="text-sm text-[#8A8A8A]">{row.standard}</p>
              </div>
            </div>
          ))}
        </div>

        {/* More Button */}
        <div className="mt-8 flex justify-end">
          <Link
            to="/karsilastirma"
            className="inline-flex items-center gap-2 text-sm font-semibold text-[#A66A3F] border border-[#A66A3F] px-5 py-2.5 hover:bg-[#A66A3F] hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Daha Fazla
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Big Metric */}
        <div className="mt-8 bg-[#2B2B2B] px-8 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-white/60 text-sm mb-1">Round-Trip Efficiency</p>
            <p className="text-5xl md:text-6xl font-bold text-[#A66A3F]">%92+</p>
            <p className="text-white/40 text-xs mt-2 tracking-wide">Endüstri ortalamasının üzerinde verim</p>
          </div>
          <div className="hidden md:block w-px h-16 bg-white/10" />
          <div className="text-center md:text-right">
            <p className="text-white/60 text-sm mb-3">Sektörde öne çıkan performans metrikleri</p>
            <div className="flex flex-wrap gap-3 justify-center md:justify-end">
              {["IEC 62619", "UL 9540", "CE", "ISO 9001"].map((cert) => (
                <span key={cert} className="text-xs font-mono text-white/70 border border-white/20 px-3 py-1">
                  {cert}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
